import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FeaturesModule } from '@flyfreely-portal-ui/features';
import { FlyFreelyTableModule } from '@flyfreely-portal-ui/flyfreely-table';
import { LoadingIndicatorModule } from '@flyfreely-portal-ui/loading-indicator';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { NgSelectModule } from '@ng-select/ng-select';
import { AirspaceModule } from 'libs/airspace/src/lib/airspace.module';
import { InlineModalModule } from 'libs/inline-modal/src/lib/inline-modal.module';
import { MapModule } from 'libs/map/src/lib/map.module';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { MissionViewMapComponent } from './mission-view-map/mission-view-map.component';
import { MissionViewSidebarComponent } from './mission-view-sidebar/mission-view-sidebar.component';
import { MissionViewService } from './mission-view.service';
import { MissionViewComponent } from './mission-view/mission-view.component';
import { MissionsGuard } from './missions.guard';
import { SitesSharedModule } from '@flyfreely-portal-ui/sites-shared';
import { MapNoticesDirective } from '@flyfreely-portal-ui/notices-shared';
import { MapExternalMissionsDirective } from '@flyfreely-portal-ui/missions-shared';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedUiModule,
        MapModule,
        NgxLoadingModule,
        AnalyticsModule,
        FlyFreelyTableModule,
        NgSelectModule,
        ButtonsModule,
        TooltipModule,
        AirspaceModule,
        InlineModalModule,

        ReactiveFormsModule,
        EnhancedHelpModule,
        RouterModule.forChild([]),
        LoadingIndicatorModule,
        FeaturesModule,
        BsDatepickerModule,
        PopoverModule,
        BsDropdownModule,
        SitesSharedModule,
        MapNoticesDirective,
        MapExternalMissionsDirective
    ],
    declarations: [
        MissionViewComponent,
        MissionViewSidebarComponent,
        MissionViewMapComponent
    ],
    providers: [MissionViewService, MissionsGuard]
})
export class MissionViewModule {}
